import {AfterViewInit, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Subscription} from "rxjs";
import {CalendarEvent} from "calendar-utils";
import {CalendarEventAction} from "angular-calendar";
import { ApiRestService } from '../_services/api-rest.service';
import { ApiRestService  as ScadApirest} from '../../Scadenzario/_services/api-rest.service';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Rma} from "../_Models/rma";
import {RmaStoreService} from "../_services/rma-store.service";
import {RmaFilter} from "../_Models/rma-filter";
import {RmaEditComponent} from "../rma-edit/rma-edit.component";
import {Scadenza} from "../../Scadenzario/Models/Scadenza";
import {EditScadenzaComponent} from "../../Scadenzario/edit-scadenza/edit-scadenza.component";
import {ScadenzeStoreService} from "../../Scadenzario/_services/scadenze-store.service";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {ClassicType} from "../../shared/models/ClassicType";
import {DomSanitizer} from "@angular/platform-browser";
import {Persona} from "../../Admin/models/persona";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-rma-calendar',
  templateUrl: './rma-calendar.component.html',
  styleUrls:['./rma-calendar.component.css']
})
export class RmaCalendarComponent implements OnInit, AfterViewInit {
  env = environment;
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField:'id',
    textField: 'label',
  };
  TipiSelezionati: ClassicType[] = [];
  Tipi: ClassicType[] = [];
  filtrife:ClassicType[] = [{id:"T", label: "Tutti"},{id:"R", label: "RMA"}]//,{id:"A",label:"Attivita"}]
  filtrifeSel:ClassicType[] = [{id:"T", label: "Tutti"}]
  subscriptions: Subscription = new Subscription();
  filtro: RmaFilter = new RmaFilter(1, 1000, undefined, undefined, undefined);
  scadenze: Rma[] = [];
  collectionSize: number = 0;
  events: CalendarEvent[] = [];
  rmaactions: CalendarEventAction[] = [
    {
      label: '<span class="badge badge-info ml-1"><i class="ti-pencil"></i></span>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.EditButton(event)
      },
    }
  ];
  scadenzeactions: CalendarEventAction[] = [
    {
      label: '<span class="badge badge-info ml-1"><i class="ti-pencil"></i></span>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.ScadEditButton(event)
      },
    },
    {
      label: '<span class="badge badge-danger ml-1"><i class="ti-trash"></i></span>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.ScadDeleteButton(event)
      },
    }
  ];
  ScadAddButton() {
    this.scadenzeStore.updateScadenzaSelezionata(new Scadenza());
    const editmodal = this.modalService.open(EditScadenzaComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<EditScadenzaComponent>editmodal.componentInstance).IsModal = true;
    (<EditScadenzaComponent>editmodal.componentInstance).added.subscribe(data=>{this.RmaStore.getList(this.filtro,true,true);});
    (<EditScadenzaComponent>editmodal.componentInstance).updated.subscribe(data=> {});
  }
  ScadEditButton(event) {
    this.scadenzeStore.updateScadenzaSelezionata(Scadenza.RmaToScadenza(this.scadenze.find(x => x.id == event.id)));
    const editmodal = this.modalService.open(EditScadenzaComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<EditScadenzaComponent>editmodal.componentInstance).IsModal = true;
    (<EditScadenzaComponent>editmodal.componentInstance).added.subscribe(data=>{});
    (<EditScadenzaComponent>editmodal.componentInstance).updated.subscribe(data=> {this.RmaStore.getList(this.filtro,true,true);});
  }
  ScadDeleteButton(event) {
    if(confirm("Sei sicuro di voler eliminare questo elemento? ")){
      this.ScadenzeApiRestService.deleteScadenza(event).subscribe(data => {
        this.RmaStore.getList(this.filtro,true, true);
      });
    }
  }
  EditButton(event) {
    this.RmaStore.updateSelected(this.scadenze.find(x => x.id == event.id));
    const editmodal = this.modalService.open(RmaEditComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<RmaEditComponent>editmodal.componentInstance).IsModal = true;
    (<RmaEditComponent>editmodal.componentInstance).added.subscribe(data=>{});
    (<RmaEditComponent>editmodal.componentInstance).updated.subscribe(data=> {this.RmaStore.getList(this.filtro,true,true);});
  }

  constructor(
    private RmaStore: RmaStoreService,
    private ApiRestService: ApiRestService,
    private modalService: NgbModal,
    private scadenzeStore: ScadenzeStoreService,
    private ScadenzeApiRestService: ScadApirest,
    protected sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.DateChanged(new Date());
    if(environment.Modules.Scadenzario)
      this.scadenzeStore.getTipi();
    this.subscriptions.add(this.RmaStore.$prodotti.subscribe(data => {
        this.scadenze = data?.data ?? [];
        this.collectionSize = data?.total ?? 0;
        this.events = this.Scadenze_To_Eventi(data?.data);
    }));
    this.subscriptions.add(this.scadenzeStore.$tipi.subscribe(data => {
      this.Tipi = [];
      if (data)
        this.Tipi = data;
    }))
  }
  ngAfterViewInit() {
  }

  Open(se: CalendarEvent){
    console.log(this.scadenze?.find(x => x.id == se.id))
    console.log(this.scadenze?.find(x => x.id == se.id)?.type)
    if(this.scadenze?.find(x => x.id == se.id)?.type?.toLocaleUpperCase() == "R")
      this.EditButton(se)
    else
      this.ScadEditButton(se);
  }
  DateChanged(value: Date) {
    if (this.filtro.anno == value.getFullYear() && this.filtro.mese == value.getMonth() + 1)
      return;
    this.filtro.page = 0;
    this.filtro.size = 1000;
    this.filtro.chiuso = undefined;
    this.filtro.anno = value.getFullYear();
    this.filtro.mese = value.getMonth()+1;
    console.log(this.filtro);
    this.RmaStore.getList(this.filtro,true,true);
  }
  Scadenze_To_Eventi(data: Rma[]): CalendarEvent[] {
    const Eventi: CalendarEvent[] = [];
    data?.forEach(element => {
      if(this.HasIDs(this.filtrifeSel, ["T", element.type]))
        Eventi.push(this.HasTypes(element.type, ["R"]) ? this.Rma_To_Event(element, this.rmaactions) : this.Scadenza_To_Event(element, this.scadenzeactions));
    });
    return Eventi;
  }
  HasIDs(oggetto: any[], ids: any[] ): boolean{
    let presente: boolean = false;
    ids?.forEach(id => presente = (presente == true ? true : oggetto?.find(x=>x?.id.toLocaleUpperCase() == id.toLocaleUpperCase()) != undefined))
    return presente;
  }
  HasTypes(oggetto: string, ids: any[] ): boolean{
    let presente: boolean = false;
    ids?.forEach(id => (presente = presente == true ? true : oggetto?.toLocaleUpperCase() == id.toLocaleUpperCase()))
    return presente;
  }
  eventTitle(scadenza: Rma): string{
    return "Ticket # " + (scadenza?.id ?  scadenza.id.toString() : "") + (scadenza?.assistenzaObject?.nominativo ?  " - " + scadenza.assistenzaObject.nominativo : "");
    // return (scadenza?.assistenzaObject?.nominativo ? scadenza.assistenzaObject.nominativo + " - ":"") + (scadenza?.seriale ? scadenza.seriale + " - ": "") + (scadenza?.matricola ? scadenza.matricola : "");
  }
  public Rma_To_Event = (scadenza: Rma, actions?: CalendarEventAction[]): CalendarEvent => {
    return {
      start: new Date(scadenza.data_inizio_prevista),
      end: new Date(scadenza.data_inizio_prevista),
      title: this.eventTitle(scadenza),
      actions: this.scadenzaaction(actions,scadenza),
      color: {
        primary: this.getRmaColor(scadenza),
        secondary: '#D1E8FF'
      },
      id: scadenza.id,
    }
  }

  getRmaColor(rma:Rma): string{
    return rma.data_inizio_effettiva && rma.data_fine_effettiva && rma.manager && rma.chiuso ? '#3cb043'
      : rma.data_inizio_effettiva && rma.data_fine_effettiva && rma.manager ? '#fcb043'
        : rma.data_fine_prevista ? '#e1e100'
          : '#ff0000';
  }





  scadenzaaction (actions: CalendarEventAction[], rma:Rma){
    const out = [].concat(actions);
    out.concat(rma.padreObject || rma?.figli?.length > 0? [
        {
          label: this.sanitizer.bypassSecurityTrustHtml('&nbsp;<span style="margin-top: 2px" class="badge badge-light-megna calendar-tooltip"> <i class="far fa-clipboard">' +
            '<span class="tooltiptext font-18" >'+
             (rma?.padreObject ? '<span class=" ">Principali: </span>' : '') +
            '<br>'+
            this.nomePadre(rma)+
            '<br>'+
            '<br>'+
            (rma?.figli?.length >0 ? '<span class=" ">Secondarie: </span>' : '') +
            '<br>'+
            this.nomifigli(rma)+
            '</span>' +
            '</span>'),
          a11yLabel: 'Info',
          onClick: ({ event }: { event: CalendarEvent }): void => {}
        }
      ]: []
    )
    return out
  }
  nomifigli(rma:Rma): string{
    var out: string = "";
    rma?.figli?.forEach(figlio=>{
      out = out + '<br>' + figlio.nome + (figlio.manager instanceof Persona ? " " + figlio.manager.fullName : '')
    })
    return out;
  }
  nomePadre(rma:Rma): string{
      return rma?.padreObject && this.HasTypes(rma.padreObject,["R"]) ?
        this.eventTitle(rma.padreObject) :
        '<br>' + rma.padreObject.nome + (rma.padreObject.manager instanceof Persona ? " " + rma.padreObject.manager.fullName : '');
  }

  eventDidMount(info){
    console.log(info);
  }
  public Scadenza_To_Event = (scadenza: Rma, actions?: CalendarEventAction[]): CalendarEvent => {

    if(scadenza && scadenza.chiuso && scadenza.manager)
      return {
        start: new Date(scadenza.data_inizio_prevista),
        end: new Date(scadenza.data_fine_prevista),
        title: scadenza.nome + " " + scadenza.manager.fullName ,
        actions: this.scadenzaaction(actions,scadenza),
        color: {
          primary: '#3cb043',
          secondary: '#3cb043'
        },
        id: scadenza.id,
      }
    else if (scadenza && !scadenza.chiuso && scadenza.manager)
      return {
        start: new Date(scadenza.data_inizio_prevista),
        end: new Date(scadenza.data_fine_prevista),
        title: scadenza.nome ,
        actions: this.scadenzaaction(actions,scadenza),
        color: {
          primary: '#e1e100',
          secondary: '#e1e100'
        },
        id: scadenza.id,
      }
    else
      return {
        start: new Date(scadenza.data_inizio_prevista),
        end: new Date(scadenza.data_fine_prevista),
        title: scadenza.nome ,
        actions: this.scadenzaaction(actions,scadenza),
        color: {
          primary: '#ff0000',
          secondary: '#ff0000'
        },
        id: scadenza.id,
      }
  }

  filtrifechng() {
    if(!this.filtrifeSel || this.filtrifeSel.length ==0 || !this.filtrifeSel[0])
      this.filtrifeSel = [{id:"T", label: "Tutti"}]
    this.RmaStore.getList(this.filtro,true, true);
  }

  TipoCambiato() {
    this.filtro.tipo = undefined;
    if(this.TipiSelezionati && this.TipiSelezionati.length > 0 && this.TipiSelezionati[0])
      this.filtro.tipo = this.TipiSelezionati[0].id;
    this.DateChanged(new Date())
  }
}
